(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anchor-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.anchor-list-item').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        const targetId = button.getAttribute('href').replace('#', '')
        const targetElement = document.querySelector(`[data-anchor-target="${targetId}"]`)

        if (targetElement) {
          const yOffset = -120
          const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset

          window.scrollTo({ top: y, behavior: 'smooth' })
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();
})();
